import { render, staticRenderFns } from "./BillingRuleFrom.vue?vue&type=template&id=d15a1dd6&scoped=true"
import script from "./BillingRuleFrom.vue?vue&type=script&lang=js"
export * from "./BillingRuleFrom.vue?vue&type=script&lang=js"
import style0 from "./BillingRuleFrom.vue?vue&type=style&index=0&id=d15a1dd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d15a1dd6",
  null
  
)

export default component.exports